import styles from './stylesheets/default.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './containers/app';
import configureStore from './store/configureStore';
import isNil from '~/_base/functions/isNil';

document.addEventListener('DOMContentLoaded', function() {
  initializeTimetravel();
});

function initializeTimetravel() {
  const rootElement = document.getElementById('react-liveview');
  const store = configureStore();

  if (!isNil(rootElement)) {
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      rootElement
    );
  }
}
